import About from "../components/site/About";

export default function AboutPage() {
  return (
    <div className="pt-24">
      <About />
    </div>
  );
}
